import type { OrderResponseDto } from '@b-stock/order-api-client'
import {
  OrderResponseDtoStatusEnum,
  PaymentStatusEnum,
} from '@b-stock/order-api-client'

const canChangeShipping = (
  order: Pick<OrderResponseDto, 'status' | 'payment'>
) => {
  if (
    order.status !== OrderResponseDtoStatusEnum.Open &&
    order.status !== OrderResponseDtoStatusEnum.Hold
  ) {
    return false
  }

  return (
    order.payment?.status === PaymentStatusEnum.Unpaid ||
    order.payment?.status === PaymentStatusEnum.Failed
  )
}

export default canChangeShipping
